import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner.png'
import _imports_2 from '../../assets/performance/bannerMeomory.jpg'
import _imports_3 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-41da0d80")

_pushScopeId("data-v-41da0d80")
const _hoisted_1 = { class: "Ecard" }
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_18 = { id: "perf_report" }
const _hoisted_19 = { class: "spacName" }
const _hoisted_20 = {
  key: 0,
  class: "banner",
  src: _imports_1,
  alt: ""
}
const _hoisted_21 = {
  key: 1,
  class: "banner",
  src: _imports_2,
  alt: ""
}
const _hoisted_22 = { class: "mainContent" }
const _hoisted_23 = { class: "spacName" }
const _hoisted_24 = { class: "gameTable" }
const _hoisted_25 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_26 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_27 = { class: "mx-2 fw-bold" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 安卓版本: ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 基线版本: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_32 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "客户端性能自动化")
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_37 = { class: "corePerformance" }
const _hoisted_38 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("总体风险，风险详情 ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("p", { class: "spacName" }, "1. 核心场景内存趋势", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 版本间核心场景初始化时内存对象波动值风险级别定义规则:内存增幅波动 <5%，低风险；5%<=内存增幅波动<8%，中风险；内存增幅波动>=8%，高风险。 ", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 对比范围:DailyBuild性能版本对比上个月最终性能版本。 ", -1)
const _hoisted_43 = { class: "scene" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", null, "内存性能趋势", -1)
const _hoisted_45 = { class: "spacName TrendChart" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", null, "1、NATIVE引擎对象总内存(MB)", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", {
  id: "engine",
  style: {"width":"100%","height":"350px"}
}, null, -1)
const _hoisted_48 = { class: "spacName TrendChart" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, "2、MONO托管对象总内存(MB)", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("div", {
  id: "mono",
  style: {"width":"100%","height":"350px"}
}, null, -1)
const _hoisted_51 = { class: "corePerformance performanceData" }
const _hoisted_52 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能数据")
], -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 分支转测后，DailyBuild性能版本对比上个月度发布前稳定版各性能指标趋势。 ", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode(" Ps: "),
  /*#__PURE__*/_createVNode("span", { class: "gray" }, "灰色为上个版本数据"),
  /*#__PURE__*/_createTextVNode(" ，白色为当前内网最新版本数据 ")
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("内存数据")
], -1)
const _hoisted_56 = { class: "performanceTitle" }
const _hoisted_57 = {
  class: "performanceTable",
  style: {"font-size":"14px","table-layout":"fixed"}
}
const _hoisted_58 = /*#__PURE__*/_createVNode("th", { style: {"width":"250px"} }, "指标", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("th", null, "对象数量", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("th", null, "对象数量", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("th", null, "对象数量占比", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("th", null, "内存占比", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("th", null, "内存变化", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("th", null, "内存趋势", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("th", null, "对象数量变化", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("th", null, "对象数量趋势", -1)
const _hoisted_67 = { style: {"width":"250px"} }
const _hoisted_68 = { class: "gray_" }
const _hoisted_69 = { class: "gray_" }
const _hoisted_70 = { class: "LINK" }
const _hoisted_71 = /*#__PURE__*/_createVNode("th", null, "链接", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_79 = {
  class: "performanceTable",
  style: {"font-size":"14px","table-layout":"fixed"}
}
const _hoisted_80 = /*#__PURE__*/_createVNode("th", { style: {"width":"250px"} }, "指标", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("th", null, "对象数量", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("th", null, "对象数量", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("th", null, "对象数量占比", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("th", null, "内存占比", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("th", null, "内存变化", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("th", null, "内存趋势", -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("th", null, "对象数量变化", -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("th", null, "对象数量趋势", -1)
const _hoisted_89 = { style: {"width":"250px"} }
const _hoisted_90 = { class: "gray_" }
const _hoisted_91 = { class: "gray_" }
const _hoisted_92 = { class: "LINK" }
const _hoisted_93 = /*#__PURE__*/_createVNode("th", null, "链接", -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("内存分析")
], -1)
const _hoisted_102 = { class: "performanceTitle" }
const _hoisted_103 = {
  class: "performanceTable",
  style: {"font-size":"14px"}
}
const _hoisted_104 = /*#__PURE__*/_createVNode("th", { rowspan: 2 }, "对象类型", -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("th", { rowspan: 2 }, "对象名称", -1)
const _hoisted_106 = { colspan: 2 }
const _hoisted_107 = { colspan: 2 }
const _hoisted_108 = /*#__PURE__*/_createVNode("th", { rowspan: 2 }, "内存占比", -1)
const _hoisted_109 = /*#__PURE__*/_createVNode("th", { rowspan: 2 }, "变化", -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("th", { rowspan: 2 }, "趋势", -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("tr", { class: "size-quantity" }, [
  /*#__PURE__*/_createVNode("th", null, "内存大小"),
  /*#__PURE__*/_createVNode("th", null, "对象数量"),
  /*#__PURE__*/_createVNode("th", null, "内存大小"),
  /*#__PURE__*/_createVNode("th", null, "对象数量")
], -1)
const _hoisted_112 = { class: "gray_" }
const _hoisted_113 = { class: "gray_" }
const _hoisted_114 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm queryReport",
                    disabled: _ctx.loading
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "报告名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.change_report
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.codm_reports, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: 
                      item.report_name
                        ? item.report_name
                        : 'CFM' +
                          '\xa0' +
                          'Dump内存测试报告-' +
                          item.cur_version +
                          '-' +
                          item.test_time.replace('/', '').replace('/', '')
                    ,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_popconfirm, {
                            onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                            title: "确认删除该报告？",
                            placement: "top"
                          }, {
                            reference: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "info",
                                disabled: _ctx.get_is_super
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: "暂无管理员权限",
                                    placement: "top",
                                    disabled: !_ctx.get_is_super
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            class: "editBtn",
                            size: "mini",
                            onClick: _ctx.handleEdit
                          }, {
                            default: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_5,
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13,
                                    _hoisted_14
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    _ctx.test_info.cur_version +
                    " - " +
                    "时间: " +
                    _ctx.test_info.test_time), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _withDirectives(_createVNode("div", _hoisted_19, [
                      (_ctx.localProject != 44)
                        ? (_openBlock(), _createBlock("img", _hoisted_20))
                        : (_openBlock(), _createBlock("img", _hoisted_21))
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _withDirectives(_createVNode("table", _hoisted_24, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_25, [
                              _createVNode("img", {
                                src: _ctx.project_info.icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_26, [
                              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.project_info.project_name), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_28,
                              _createVNode("span", null, _toDisplayString(_ctx.test_info.month), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_29,
                              _createVNode("span", null, _toDisplayString(_ctx.test_info.test_time), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_30,
                              _createVNode("span", null, _toDisplayString(_ctx.test_info.old_month.split(".")[0] +
                          "年" +
                          _ctx.test_info.old_month.split(".")[1] +
                          "月版本  " +
                          _ctx.test_info.old_version), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_31,
                              _createVNode("span", {
                                style: _ctx.get_risk_color(_ctx.com_risk)
                              }, [
                                _createVNode("b", null, _toDisplayString(_ctx.com_risk), 1)
                              ], 4)
                            ]),
                            _hoisted_32,
                            _createVNode("td", null, [
                              _hoisted_33,
                              _createVNode("span", null, _toDisplayString(_ctx.test_info.month.split(".")[0] +
                          "年" +
                          _ctx.test_info.month.split(".")[1] +
                          "月版本  " +
                          _ctx.test_info.cur_version), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _createVNode(_component_el_dialog, {
                        modelValue: _ctx.dialogFormVisible1,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
                        width: "30%"
                      }, {
                        footer: _withId(() => [
                          _createVNode("span", _hoisted_34, [
                            _createVNode(_component_el_button, {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_35
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.dialogFormVisible2
                            }, {
                              default: _withId(() => [
                                _hoisted_36
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_form, {
                            class: "demo-form-reportreport com_input",
                            inline: true
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, {
                                class: "reportName",
                                label: "报告名称"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    size: "small",
                                    class: "report-input",
                                    modelValue: _ctx.report_name,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.report_name = $event)),
                                    autocomplete: "off",
                                    width: "500"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _withDirectives(_createVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _hoisted_41,
                        _hoisted_42,
                        _createVNode(_component_el_table, {
                          data: _ctx.core_data,
                          "header-cell-class-name": "TestConclusion",
                          "cell-class-name": "TestConclusionTable"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "scene",
                              label: "测试场景",
                              width: "280"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", _hoisted_43, _toDisplayString(scope.row.scene) + " " + _toDisplayString(scope.row.scene_id), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: 
                        '内存性能趋势' +
                        _ctx.test_info.cur_version +
                        '(对比' +
                        _ctx.test_info.old_version +
                        ')'
                      
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "trend",
                                  label: "引擎对象总内存趋势"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: _ctx.get_trend_color(scope.row.engine, 1)
                                    }, _toDisplayString(scope.row.engine), 5)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "trend2",
                                  label: "托管对象总内存趋势"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: _ctx.get_trend_color(scope.row.mono, 1)
                                    }, _toDisplayString(scope.row.mono), 5)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "object",
                                  label: "内存增幅TOP1对象"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: _ctx.get_trend_color(scope.row.engine, 0)
                                    }, _toDisplayString(scope.row.engine_top), 5),
                                    _createVNode("p", {
                                      style: _ctx.get_trend_color(scope.row.mono, 0)
                                    }, _toDisplayString(scope.row.mono_top), 5)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "risk",
                              label: "趋势风险"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: _ctx.get_risk_color(scope.row.risk)
                                }, _toDisplayString(scope.row.risk), 5)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_44,
                        _createVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _withDirectives(_createVNode(_component_el_card, { class: "FPStrend" }, {
                            default: _withId(() => [
                              _hoisted_47
                            ]),
                            _: 1
                          }, 512), [
                            [_directive_loading, _ctx.loading]
                          ])
                        ]),
                        _createVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _withDirectives(_createVNode(_component_el_card, { class: "FPStrend" }, {
                            default: _withId(() => [
                              _hoisted_50
                            ]),
                            _: 1
                          }, 512), [
                            [_directive_loading, _ctx.loading]
                          ])
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _hoisted_53,
                        _hoisted_54,
                        _createVNode("div", null, [
                          _hoisted_55,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memory_data, (value, key, index) => {
                            return (_openBlock(), _createBlock("div", { key: key }, [
                              _createVNode("p", _hoisted_56, _toDisplayString(index + 1) + ". " + _toDisplayString(key.toUpperCase()) + "_初始化内存 ", 1),
                              _createVNode("table", _hoisted_57, [
                                _createVNode("tr", null, [
                                  _createVNode("th", {
                                    class: _ctx.get_color(value.engine[0].trend, 1),
                                    colspan: 11,
                                    style: {"height":"30px"}
                                  }, _toDisplayString(_ctx.project_info.project_name) + "_引擎对象内存 ", 3)
                                ]),
                                _createVNode("tr", null, [
                                  _hoisted_58,
                                  _createVNode("th", null, _toDisplayString(_ctx.test_info.old_version), 1),
                                  _hoisted_59,
                                  _createVNode("th", null, _toDisplayString(_ctx.test_info.cur_version), 1),
                                  _hoisted_60,
                                  _hoisted_61,
                                  _hoisted_62,
                                  _hoisted_63,
                                  _hoisted_64,
                                  _hoisted_65,
                                  _hoisted_66
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.engine, (item, i) => {
                                  return (_openBlock(), _createBlock("tr", {
                                    class: "mo_tr",
                                    key: i
                                  }, [
                                    _createVNode("td", _hoisted_67, _toDisplayString(item.item), 1),
                                    _createVNode("td", _hoisted_68, _toDisplayString(item.baseline), 1),
                                    _createVNode("td", _hoisted_69, _toDisplayString(item.cnt), 1),
                                    _createVNode("td", null, _toDisplayString(item.size), 1),
                                    _createVNode("td", null, _toDisplayString(item.cnt), 1),
                                    _createVNode("td", null, _toDisplayString(item.ratio_cnt), 1),
                                    _createVNode("td", null, _toDisplayString(item.ratio), 1),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend, 0)
                                    }, _toDisplayString(item.change), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend, 0)
                                    }, _toDisplayString(item.trend), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend_cnt, 0)
                                    }, _toDisplayString(item.change_cnt), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend_cnt, 0)
                                    }, _toDisplayString(item.trend_cnt), 3)
                                  ]))
                                }), 128)),
                                _createVNode("tr", _hoisted_70, [
                                  _hoisted_71,
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      target: "_blank",
                                      href: _ctx.compare_link
                                    }, "链接", 8, ["href"])
                                  ]),
                                  _hoisted_72,
                                  _createVNode("td", null, [
                                    _createVNode("a", { href: _ctx.link }, "链接", 8, ["href"])
                                  ]),
                                  _hoisted_73,
                                  _hoisted_74,
                                  _hoisted_75,
                                  _hoisted_76,
                                  _hoisted_77,
                                  _hoisted_78
                                ])
                              ]),
                              _createVNode("table", _hoisted_79, [
                                _createVNode("tr", null, [
                                  _createVNode("th", {
                                    class: _ctx.get_color(value.mono[0].trend, 1),
                                    colspan: 11,
                                    style: {"height":"30px"}
                                  }, _toDisplayString(_ctx.project_info.project_name) + "_托管对象内存 ", 3)
                                ]),
                                _createVNode("tr", null, [
                                  _hoisted_80,
                                  _createVNode("th", null, _toDisplayString(_ctx.test_info.old_version), 1),
                                  _hoisted_81,
                                  _createVNode("th", null, _toDisplayString(_ctx.test_info.cur_version), 1),
                                  _hoisted_82,
                                  _hoisted_83,
                                  _hoisted_84,
                                  _hoisted_85,
                                  _hoisted_86,
                                  _hoisted_87,
                                  _hoisted_88
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.engine, (item, i) => {
                                  return (_openBlock(), _createBlock("tr", {
                                    class: "mo_tr",
                                    key: i
                                  }, [
                                    _createVNode("td", _hoisted_89, _toDisplayString(value.mono[i].item), 1),
                                    _createVNode("td", _hoisted_90, _toDisplayString(value.mono[i].baseline), 1),
                                    _createVNode("td", _hoisted_91, _toDisplayString(value.mono[i].base_cnt), 1),
                                    _createVNode("td", null, _toDisplayString(value.mono[i].size), 1),
                                    _createVNode("td", null, _toDisplayString(value.mono[i].cnt), 1),
                                    _createVNode("td", null, _toDisplayString(value.mono[i].ratio_cnt), 1),
                                    _createVNode("td", null, _toDisplayString(value.mono[i].ratio), 1),
                                    _createVNode("td", {
                                      class: _ctx.get_color(value.mono[i].trend, 0)
                                    }, _toDisplayString(value.mono[i].change), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(value.mono[i].trend, 0)
                                    }, _toDisplayString(value.mono[i].trend), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(value.mono[i].trend_cnt, 0)
                                    }, _toDisplayString(value.mono[i].change_cnt), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(value.mono[i].trend_cnt, 0)
                                    }, _toDisplayString(value.mono[i].trend_cnt), 3)
                                  ]))
                                }), 128)),
                                _createVNode("tr", _hoisted_92, [
                                  _hoisted_93,
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      target: "_blank",
                                      href: _ctx.compare_link
                                    }, "链接", 8, ["href"])
                                  ]),
                                  _hoisted_94,
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      target: "_blank",
                                      href: _ctx.link
                                    }, "链接", 8, ["href"])
                                  ]),
                                  _hoisted_95,
                                  _hoisted_96,
                                  _hoisted_97,
                                  _hoisted_98,
                                  _hoisted_99,
                                  _hoisted_100
                                ])
                              ])
                            ]))
                          }), 128)),
                          _hoisted_101,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memory_analysis, (value, key, index) => {
                            return (_openBlock(), _createBlock("div", { key: key }, [
                              _createVNode("p", _hoisted_102, _toDisplayString(index + 1) + ".【" + _toDisplayString(key.toUpperCase()) + "_初始化】引擎对象内存占比TOP1变化详情 ", 1),
                              _createVNode("table", _hoisted_103, [
                                _createVNode("tr", null, [
                                  _createVNode("th", {
                                    class: _ctx.get_color(value.engine[0].trend, 1),
                                    colspan: 9,
                                    style: {"height":"30px"}
                                  }, _toDisplayString(_ctx.project_info.project_name) + "_ " + _toDisplayString(key) + "_dev_引擎对象内存 ", 3)
                                ]),
                                _createVNode("tr", null, [
                                  _hoisted_104,
                                  _hoisted_105,
                                  _createVNode("th", _hoisted_106, _toDisplayString(_ctx.test_info.old_version), 1),
                                  _createVNode("th", _hoisted_107, _toDisplayString(_ctx.test_info.cur_version), 1),
                                  _hoisted_108,
                                  _hoisted_109,
                                  _hoisted_110
                                ]),
                                _hoisted_111,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.engine, (item, i) => {
                                  return (_openBlock(), _createBlock("tr", { key: i }, [
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("th", {
                                          key: 0,
                                          rowspan: value.engine.length
                                        }, _toDisplayString(value.type), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    _createVNode("th", null, _toDisplayString(item.item), 1),
                                    _createVNode("td", _hoisted_112, _toDisplayString(item.base_size), 1),
                                    _createVNode("td", _hoisted_113, _toDisplayString(item.base_number), 1),
                                    _createVNode("td", null, _toDisplayString(item.size), 1),
                                    _createVNode("td", null, _toDisplayString(item.number), 1),
                                    _createVNode("td", null, _toDisplayString(item.ratio), 1),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend, 0)
                                    }, _toDisplayString(item.change), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend, 0)
                                    }, _toDisplayString(item.trend), 3)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _hoisted_114
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})